<script setup lang="ts">
import { PV } from "@/widgets";
import Icon from "~icons/ic/baseline-edit";

defineEmits<{
    click: [];
}>();
</script>

<template>
    <PV.Button v-tooltip.left="'Ubah'" class="p-0!" link @click="$emit('click')">
        <Icon class="text-gray-500 hover:text-gray-700 hover:cursor-pointer" />
    </PV.Button>
</template>
